import http from '@/utils/http'

export function getGrades(params){
    return http.get('/grades',{params})
}
export function addGrade(data){
    return http.post('/grades',data)
}
export function getGradeDetail(id){
    return http.get(`/grades/${id}`)
}
export function putGrade(id,data){
    return http.put(`/grades/${id}`,data)
}
export function deleteGrade(id){
    return http.delete(`/grades/${id}`)
}
export function getGradeDistributionRequest(id,data){
    return http.post(`/grades/${id}/distribution_request`,data)
}